import Swiper from 'swiper';

const swiperContainerClass = '.instagram__swiper';

function initSlider(container) {
  const swiper = new Swiper(container, {
    spaceBetween: 8,
    slidesPerView: 'auto',
    breakpoints: {
      1400: {
        slidesPerView: 7,
      },
    },
  });

  const { slides } = swiper;

  Array.from(slides).forEach((slide, index) => {
    const link = slide.querySelector('.instagram__link');
    link.addEventListener('focus', () => {
      swiper.slideTo(index, 700, false);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const initAllSliders = () => {
    const instagramFeedAll = document.querySelectorAll(swiperContainerClass);
    instagramFeedAll.forEach((el) => {
      initSlider(el);
    });
  };

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/instagram-feed', () => {
      initAllSliders();
    });
  } else {
    initAllSliders();
  }
});
